import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faTags } from '@fortawesome/free-solid-svg-icons';

const MiniDashboardDigitalArchive = ({ numberOfFiles, uniquePrefixes }) => {
  return (
    <div className="bg-white shadow rounded-lg p-3 w-full mb-4">
      <div className="grid grid-cols-2 divide-x divide-gray-200 text-center">
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faFile} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Number of Files</p>
          <p className="text-lg font-semibold text-gray-800">{numberOfFiles}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-2">
          <FontAwesomeIcon icon={faTags} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Unique Prefixes</p>
          <p className="text-lg font-semibold text-gray-800">{uniquePrefixes}</p>
        </div>
      </div>
    </div>
  );
};

export default MiniDashboardDigitalArchive;
